import React from 'react';
import './LoadingScreen.scss';

const LoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <div className="loading-screen__container">
        <div className="loading-screen__spinner" aria-hidden="true"></div>
        <div className="loading-screen__message">{message}</div>
        <div className="loading-screen__progress">
          <div className="loading-screen__progress-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
